module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "Paginator"
  }, [_c(_vm.reverseRoute ? 'router-link' : 'div', {
    tag: "component",
    staticClass: "Paginator-buttonLink",
    attrs: {
      "to": _vm.reverseRoute
    }
  }, [_c('button-component', {
    staticClass: "Paginator-button",
    attrs: {
      "icon": "arrow-left",
      "disabled": !_vm.reverseRoute
    }
  })], 1), _vm._v(" "), (_vm.pagesLabel) ? _c('p', {
    staticClass: "Paginator-pages",
    domProps: {
      "innerHTML": _vm._s(_vm.pagesLabel)
    }
  }) : _vm._e(), _vm._v(" "), _c(_vm.forwardRoute ? 'router-link' : 'div', {
    tag: "component",
    staticClass: "Paginator-buttonLink",
    attrs: {
      "to": _vm.forwardRoute
    }
  }, [_c('button-component', {
    staticClass: "Paginator-button",
    attrs: {
      "icon": "arrow-right",
      "disabled": !_vm.forwardRoute
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e014ce2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Paginator.vue
// module id = 748
// module chunks = 1474